<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>

      <v-col cols="4">
        <v-text-field
          v-model="search"
          single-line
          append-icon="mdi-magnify"
          :label="$t('Search')"
          hide-details
          clearable
        >
          <v-icon slot="append" @click="searchItem()">
            mdi-magnify</v-icon
          ></v-text-field
        >
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="agents"
      :items-per-page.sync="itemsPerPage"
      :options.sync="options"
      class="elevation-1 ma-3 pa-4"
      hide-default-footer
      v-if="agents"
      :no-data-text="$t('No data available')"
    >
      <template v-slot:[`item.actionBill`]="{ item }">
        <v-row no-gutters>
          <v-col cols="4">
            <v-switch
              v-model="item.IsBillToSalesAgent"
              color="primary"
              @click="toggleAgentBillTo(item.Id)"
              class="float-left mr-3"
            ></v-switch>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <email-buttons
          :item="item"
          :request="requestItem"
          :isAgents="true"
          @userFeedback="userFeedback"
        />
      </template>
      <template v-slot:footer>
        <v-row class="mx-2 py-2" align="center" justify="center">
          <v-spacer></v-spacer>

          <span class="mr-4 grey--text">
            <small
              >{{ $t("Page") }} {{ getPage }} {{ $t("out of") }}
              {{ getAmountOfPages }}</small
            >
          </span>
          <v-btn
            :disabled="hasPrevPage"
            fab
            x-small
            class="mr-1"
            @click="formerPage()"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            :disabled="hasNextPage"
            fab
            x-small
            class="ml-1"
            @click="nextPage()"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
    </v-data-table>
    <v-snackbar v-model="alert" :color="alertType" dense :type="alertType">
      {{ alertText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" v-bind="attrs" @click="alert = false" icon>
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import request from "../../request";
import helpers from "../../helpers";
import EmailButtons from "../shared/EmailButtons.vue";
export default {
  components: { EmailButtons },
  data() {
    return {
      options: {},
      switchItem: [],
      agents: [],
      search: "",
      amountOfPages: 1,
      page: 1,
      count: 10,
      start: 0,
      itemsPerPage: 10,
      requestItem: request,
      alert: false,
      alertType: "success",
      alertText: "",
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("Name"),
          align: "start",
          sortable: true,
          value: "Name",
        },
        {
          text: this.$t("Last modified"),
          sortable: false,
          value: "LastModified",
        },
        {
          text: this.$t("Bill to"),
          value: "actionBill",
          sortable: false,
        },
        {
          text: this.$t("Actions"),
          value: "action",
          sortable: false,
        },
      ];
    },
    getPage: {
      get() {
        return this.page;
      },
      set(newItem) {
        this.page = newItem;
      },
    },
    hasPrevPage() {
      if (this.getPage == 1) {
        return true;
      }
      return false;
    },
    hasNextPage() {
      if (this.getPage < this.amountOfPages) {
        return false;
      }
      return true;
    },
    getAmountOfPages: {
      get() {
        if (this.amountOfPages == 0) {
          return 1;
        }
        return this.amountOfPages;
      },
      set(newItem) {
        this.amountOfPages = newItem;
      },
    },
  },
  created() {
    request.get("/api/kdesign/agents?start=0&count=10", null, (res) => {
      if (res.success) {
        res.forEach((element, index) => {
          res[index].LastModified = helpers.changeTimeToReadeble(
            element.LastModified
          );

          res[index]["HasAccessToSalesAgent"] = element.IsSalesAgent;

          this.agents.push(element);
        });
      }
    });
  },
  watch: {
    search: function (params) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        params ? params : (params = "");
        this.page = 0;
        this.start = 0;
        this.count = 10;
        this.getAgents({
          start: this.start,
          count: this.count,
          search: params,
          sort: this.options.sortBy.length > 0 ? this.options.sortBy[0] : "",
          sortDescending:
            this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : false,
        });
      }, 800);
    },
    options: {
      handler() {
        this.getAgents({
          start: this.start,
          count: this.count,
          search: this.search ? this.search : "",
          sort: this.options.sortBy.length > 0 ? this.options.sortBy[0] : "",
          sortDescending:
            this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : false,
        });
      },
      deep: true,
    },
  },
  methods: {
    toggleAgentActivity(item) {
      request.put(
        "/api/kdesign/toggle-customer-role?role=SalesAgent&customerId=" +
          item.Id,
        null,
        () => {
          return;
        }
      );
    },
    toggleAgentBillTo(id) {
      request.put(
        "/api/kdesign/agent-toggle-is-bill-to?customerId=" + id,
        null,
        () => {
          return;
        }
      );
    },
    getAgents(items) {
      request.get(
        "/api/kdesign/agents?start=" +
          items.start +
          "&count=" +
          items.count +
          "&sort=" +
          items.sort +
          "&sortDescending=" +
          items.sortDescending +
          "&search=" +
          items.search,
        null,
        (res) => {
          this.agents = [];
          res.forEach((element, index) => {
            res[index].LastModified = helpers.changeTimeToReadeble(
              element.LastModified
            );
            res[index]["HasAccessToSalesAgent"] = element.IsSalesAgent;

            this.agents.push(element);
          });
        }
      );
      this.getAgentsCount(items);
    },
    getAgentsCount(items) {
      request.get(
        "/api/kdesign/agentscount?start=" +
          items.start +
          "&count=" +
          items.count +
          "&search=" +
          items.search,
        null,
        (res) => {
          this.amountOfPages = Math.ceil(res.item / this.itemsPerPage);
        }
      );
    },
    nextPage() {
      this.page++;
      this.start = this.start + this.itemsPerPage;
      this.getAgents({
        start: this.start,
        count: this.count,
        search: this.search ? this.search : "",
        sort: this.options.sortBy.length > 0 ? this.options.sortBy[0] : "",
        sortDescending:
          this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : false,
      });
    },
    formerPage() {
      this.page--;
      this.start = this.start - this.itemsPerPage;
      this.getAgents({
        start: this.start,
        count: this.count,
        search: this.search ? this.search : "",
        sort: this.options.sortBy.length > 0 ? this.options.sortBy[0] : "",
        sortDescending:
          this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : false,
      });
    },
    userFeedback(event) {
      this.alert = event.alert;
      this.alertType = event.alertType;
      this.alertText = event.alertText;
    },
  },
};
</script>

<style>
</style>